import { Alert, Box, Button, CircularProgress, Paper, Typography } from '@mui/material';
import { ReceiptLongOutlined } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

const ConfiguredRutState = ({ loading, error, onRetry }) => {
  const { t } = useTranslation();

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 6 }}>
        <CircularProgress aria-label="Cargando configuración de facturación" />
      </Box>
    );
  }

  if (error) {
    return (
      <Box sx={{ px: { xs: 2, md: 3 }, py: 4 }}>
        <Alert
          severity="error"
          action={onRetry ? <Button color="inherit" size="small" onClick={onRetry}>{t('retry')}</Button> : null}
        >
          {t('billing_configuration_load_error')}
        </Alert>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: 'calc(100vh - 112px)',
        px: { xs: 2, md: 3 },
        py: 4
      }}
    >
      <Paper
        variant="outlined"
        sx={{
          width: '100%',
          maxWidth: 640,
          p: { xs: 3, md: 5 },
          textAlign: 'center',
          borderRadius: 3,
          borderColor: 'divider',
          bgcolor: 'background.paper',
          transform: 'translateY(-24px)'
        }}
      >
        <Box
          sx={{
            width: 56,
            height: 56,
            mx: 'auto',
            mb: 2,
            display: 'grid',
            placeItems: 'center',
            borderRadius: '50%',
            bgcolor: 'grey.200',
            color: 'grey.700'
          }}
        >
          <ReceiptLongOutlined fontSize="large" />
        </Box>
        <Typography variant="h6" fontWeight={700} gutterBottom>
          {t('billing_configuration_empty_title')}
        </Typography>
        <Typography color="text.secondary" sx={{ maxWidth: 490, mx: 'auto', mb: 3 }}>
          {t('billing_configuration_empty')}
        </Typography>
      </Paper>
    </Box>
  );
};

export default ConfiguredRutState;
